export default "__VITE_ASSET__DtF2Njjj__"